// 获取日期中的月和日 支持任何格式日期 返回 12-09
export const getMonthAndDay = (date) => {
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  return `${month}-${day}`;
};

// 获取日期中的年份 支持任何格式日期 返回 1992
export const getYear = (date) => {
  if (!date) return "";
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  return year;
};
